module.exports = __webpack_public_path__ + "static/media/appstore_button.fd56b7d9.png";